module.exports = __webpack_public_path__ + "img/joint2.71ff4c2.jpg";